export const ZD_OPTIONS_USOYO = [
  "INN",
  "DealerName",
  "City",
  "code",
  "ZdUpdatedAt",
  "StatusUpdatedAt",
  "status",
];
